import { TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export type TProcessFactoryAssignTablePayload = {
  dayCapacity: number;
  factoryId: string;
};

export const PROCESS_FACTORY_ASSIGN_TABLE_MODEL = {
  createModel: (
    res: TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING['processes'][number],
    factories: TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING['availableFactories'],
  ) => {
    return ModifiersZTableModel.createTableModel(
      res.factoryInfoToDayCapacities,
      {
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'Factory Name',
            widthInPx: 150,
            liftedInput: {
              input: {
                type: 'DROPDOWN',
                options: factories
                  .filter((f) => !res.factoryInfoToDayCapacities.some((x) => x.factory.factoryId === f.factoryId))
                  .map((f) => ({ value: f.factoryId, displayName: f.factoryName })),
                isMulti: false,
                setValue: (f) => f.factory.factoryId,
              },
              metadata: { keyName: 'factoryId', isRequired: true, noEditsInTable: true },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'Day Capacity',
            widthInPx: 150,
            liftedInput: {
              input: { type: 'INPUT', subType: 'number', min: 0, setValue: (f) => f.dayCapacity },
              metadata: { keyName: 'dayCapacity', isRequired: true },
            },
          },
        ],
        edit: {
          hasAddRow: true,
          hasDeleteRow: false,
        },
      },
      (
        item,
      ): TTableRowNode<
        TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING['processes'][number]['factoryInfoToDayCapacities'][number]
      > => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            { type: 'TEXT_CELL', text: item.factory.factoryName },
            { type: 'TEXT_CELL', text: item.dayCapacity },
          ],
        };
      },
    );
  },
};
